<!-- eslint-disable max-len -->
<template>
  <div>
    <mainHeader />

    <div class="page-content pt-0 pb-0">
      <div class="wrapper">
        <router-view />
      </div>
    </div>

    <mainFooter />
  </div>
</template>

<!-- eslint-disable -->
<script>
var clicky_site_ids = clicky_site_ids || [];
clicky_site_ids.push(101061215);
(function() {
  var s = document.createElement('script');
  s.type = 'text/javascript';
  s.async = true;
  s.src = '//static.getclicky.com/js';
  (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(s);
})();
</script>

<script>
import userInfo from '@/services/userInfo';
import firebase from '@/services/firebase';
import store from '@/store';
import mainHeader from '@/components/mainHeader.vue';
import mainFooter from '@/components/mainFooter.vue';

export default {
  name: 'null',
  store,
  components: { mainHeader, mainFooter },
};
</script>
